'use es6';

import { Map as ImmutableMap } from 'immutable';
import ActionTypes from '../actions/ActionTypes';
const INITIAL_STATE = ImmutableMap({
  data: null,
  hasError: false,
  recentError: null,
  isRequesting: false
});
export default function Pricing(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.PRODUCTS_REQUESTING:
      return state.merge({
        isRequesting: true,
        hasError: false
      });

    case ActionTypes.PRODUCTS_RECEIVED:
      return state.merge({
        isRequesting: false,
        hasError: false,
        data: action.payload
      });

    case ActionTypes.PRODUCTS_ERROR:
      return state.merge({
        isRequesting: false,
        hasError: true,
        recentError: action.payload
      });

    default:
      return state;
  }
}